import { Container, Row } from "reactstrap";
import AdditionalAlert from "./AdditionalAlert";
import AlertWithIcons from "./AlertWithIcons/AlertWithIcons";
import DismissingDarkAlert from "./DismissingDarkAlert";
import DismissingLightAlert from "./DismissingLightAlert";
import LeftBorderAlert from "./LeftBorderAlert";
import { Breadcrumbs } from "../../../AbstractElements";
import { Alert, IconsWithAlerts, LinkColorTitle, LinkLightColorTitle, UIKits } from "../../../Constants/Constants";
import LiveAlert from "./LiveAlert";
import OutlineAlert from "./OutlineAlert/OutlineAlert";
import CommonLinkColor from "./CommonLinkColor";
import { AlertColorData, AlertLightColorData } from "../../../Data/UiKits/Alert";
import { Fragment } from "react/jsx-runtime";
import CustomAlertPopup from "./CustomAlertPopup";

const AlertContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Alert} parent={UIKits} />
      <Container fluid>
        <Row>
          <CommonLinkColor title={LinkColorTitle} data={AlertColorData} text/>
          <CommonLinkColor title={LinkLightColorTitle} data={AlertLightColorData} />
          <OutlineAlert />
          <AlertWithIcons />
          <LiveAlert />
          <DismissingDarkAlert />
          <DismissingLightAlert />
          <LeftBorderAlert />
          <CustomAlertPopup />
          <CommonLinkColor title={IconsWithAlerts} data={AlertColorData} bodyClass="alerts-icon" icon/>
          <AdditionalAlert />
        </Row>
      </Container>
    </Fragment>
  );
};
export default AlertContainer;
